// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__vs9mu","consentsList":"PatientConsents_consentsList__3IJg2","consentsListEmpty":"PatientConsents_consentsListEmpty__2nRQb"};